import { render, staticRenderFns } from "./MenuInterno.vue?vue&type=template&id=402c478c&scoped=true&"
import script from "./MenuInterno.vue?vue&type=script&lang=js&"
export * from "./MenuInterno.vue?vue&type=script&lang=js&"
import style0 from "./MenuInterno.vue?vue&type=style&index=0&id=402c478c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c478c",
  null
  
)

export default component.exports